import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTextChat = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 11.98,
	height: 10.5,
	viewBox: "0 0 11.98 10.5",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", { d: "M12,4.9c0,2.67-2.67,4.85-6,4.85a7.14,7.14,0,0,1-2.52-.46A5.38,5.38,0,0,1,.19,10.5.18.18,0,0,1,0,10.39a.2.2,0,0,1,0-.21A6,6,0,0,0,1.34,7.94,4.31,4.31,0,0,1,0,4.88C0,2.18,2.66,0,6,0S12,2.22,12,4.9Zm-8.27,0a.75.75,0,0,0-1.5,0A.74.74,0,0,0,3,5.62.72.72,0,0,0,3.71,4.9Zm3,0a.73.73,0,1,0-1.46,0A.72.72,0,0,0,6,5.62.71.71,0,0,0,6.71,4.9Zm3,0a.75.75,0,0,0-1.5,0A.74.74,0,0,0,9,5.62.72.72,0,0,0,9.71,4.9Z" })]
});
const ForwardRef = forwardRef(SvgTextChat);
export default ForwardRef;
